import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { select, selectAll, selection } from 'd3';
import { eventDrops } from 'ansyn-event-drops';


import { TimelineEmitterService } from '../../services/timeline-emitter.service';
import { isEqual } from 'lodash';

export const BASE_DROP_COLOR = '#d393e1';

selection.prototype.moveToFront = function () {
	return this.each(function () {
		this.parentNode.appendChild(this);
	});
};

@Component({
	selector: 'ansyn-timeline',
	templateUrl: './timeline.component.html',
	styleUrls: ['./timeline.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush
})


export class TimelineComponent implements OnInit {
	@ViewChild('context') context: ElementRef;


	private _drops: any[];
	private _markup: any[];

	@Input() configuration: any;

	@Input() redraw$: EventEmitter<any>;

	@Input()
	set markup(value) {
		if (!isEqual(this._markup, value)) {
			this._markup = value;
			this.drawMarkup();
		}
	}

	@HostListener('window:resize')
	onresize() {
		this.redraw$.emit();
	}

	@Input()
	set drops(drops: any[]) {
		this._drops = drops || [];
		this.eventDropsHandler();
		if (this._drops.length > 0 && this._markup) {
			this.drawMarkup();
			this.fixMetaballs()

		}
		// this.stream.next();

	}

	get drops() {
		return this._drops;
	}

	fixMetaballs() {
		selectAll('.drop-line')
			.append('rect')
			.attr('x', 0)
			.attr('y', 20)
			.attr('height', 40)
			.attr('width', 1)
			.attr('fill', 'transparent')
	}

	drawMarkup() {

		selectAll('.drop.displayed').classed('displayed ', false);
		selectAll('.drop.active').classed('active', false);
		selectAll('.drop.favorites').classed('favorites', false).style('filter', 'none');
		const actives = <any>selectAll('.drop.hover');
		actives.classed('hover', false);

		const nodes = [];
		this._markup.forEach(markupItem => {
			const element = document.querySelector(`circle[data-id="${markupItem.id}"]`);
			if (element) {
				element.classList.add(markupItem.class);
				nodes.push(element);
			}
		});
		if (nodes.length > 0) {
			const selection = (<any>selectAll(nodes));
			selection.moveToFront();
			actives.moveToFront();
		}

		selectAll('.drop.favorites').style('filter', 'url(#highlight)');
	}

	get markup() {
		return this._markup;
	}


	constructor(protected emitter: TimelineEmitterService) {
	}

	ngOnInit() {
		this.redraw$.subscribe(value => {
			if (this.drops) {
				this.eventDropsHandler();
				this.drawMarkup();
			}
		});
	}

	clickEvent() {
		const tolerance = 5;
		let down, wait;
		const dist = (a, b) => Math.sqrt(Math.pow(a[0] - b[0], 2) + Math.pow(a[1] - b[1], 2));


		return (data, index, nodes, event: MouseEvent) => {
			if (!down) {
				down = [event.clientX, event.clientY];
				wait = window.setTimeout((() => {
					wait = null;
					down = null;
					// this.toggleDrop(nodes[index]);
					this.emitter.provide('timeline:click').next({ event, element: data, index, nodes });
				}), 300);
			} else {
				if (dist(down, [event.clientX, event.clientY]) < tolerance) {
					this.selectAndShowDrop(nodes[index], event, data, index, nodes);
				}
				if (wait) {
					window.clearTimeout(wait);
					wait = null;
					down = null;
				}
				return;
			}
		};
	}

	selectAndShowDrop(element, event, data, index, nodes) {
		this.emitter.provide('timeline:dblclick').next({ event, element: data, index, nodes });
	}

	toggleDrop(element) {
		// d3.select(element)['moveToFront']();
		// element.classList.toggle('selected');
	}

	eventDropsHandler(): void {
		// console.log(eventDrops);
		// return;
		const chart = eventDrops(this.configuration)
			.mouseout(data => this.emitter.provide('timeline:mouseout').next(data))
			.mouseover(data => this.emitter.provide('timeline:mouseover').next(data))
			.zoomend((result) => this.emitter.provide('timeline:zoomend').next(result))
			.zoomStreamCallback(result => this.emitter.provide('timeline:zoomStream').next(result))
			.eventColor(BASE_DROP_COLOR)
			.click(this.clickEvent())
			.dblclick(() => {
				event.stopPropagation();
			});


		const dataSet = this.drops.map(entities => ({
			name: entities.name || '',
			data: entities.data
		}));

		const element = select(this.context.nativeElement)
			.datum(dataSet);

		chart(element);

		if (this._markup) {
			this.drawMarkup();
		}

	}
}



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/overlays/components/timeline/timeline.component.ts